import {Component, OnInit, Input} from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";

@Component({
  selector: 'app-student-related-disbursements',
  templateUrl: './student-related-disbursements.component.html',
  styleUrls: ['./student-related-disbursements.component.css'],
  providers: [DiamondPayDataService]
})
export class StudentRelatedDisbursementsComponent implements OnInit {

  @Input() studentId: string;

  private disbursements: any[] = [];

  constructor(private dataService:  DiamondPayDataService) { }

  ngOnInit() {
      this.dataService.RetrieveRelatedDisbursements(this.studentId)
      .subscribe((data:any[]) => this.disbursements = data, error => console.log(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/student-related-disbursements/student-related-disbursements.component.ts